import React  from 'react';
import { NavBar } from './NavBar';
import { Navigate, Outlet } from 'react-router-dom';
import { useAppSelector } from '../redux/hooks';
import { navAdminLinks, navComunLinks } from './NavBar.links';

export const RouterLayout: React.FC<{}> = () => {
    const {isAuth} = useAppSelector((state) => state.authReducer)


    return isAuth? (
        <>
            <NavBar navComunLinks={navComunLinks} navAdminLinks={navAdminLinks}/>
            <Outlet />
        </>
    ): (
        <Navigate to= '/login' />
    )
}  